export enum STATUS_STEP_ACTION {
    REMT = 'REMT',
    ROSR = 'ROSR',
    FCC = 'FCC',
    ETA = 'ETA',
    OSR = 'OSR',
    SOSR = 'SOSR', // SOSR: Special OSR for PACE US
    TRAV = 'TRAV',
    CRM = 'CRM',
    SCRM = 'SCRM',
    ESCALATE = 'ESCALATE',
    FORMS = 'FORMS',
    ATS = 'ATS', // Safety Assessment Form
}

export const ATS_FORM = 'ATS Form';
